import { gql } from "lib/apolloClient";
import { studentAttendanceFragment } from "./AttendanceSummaryFragments";

export const createAttendanceExcusalMutation = gql`
  mutation createAttendanceExcusal(
    $studentId: ID!
    $durationType: ATTENDANCE_EXCUSAL_DURATION_TYPE_ENUM
    $startDate: String
    $endDate: String
    $reason: String
    $periodIds: [ID!]
    $attachments: [AttachmentInput!]
    $curriculumProgramId: ID
  ) {
    platform {
      createAttendanceExcusal(
        input: {
          studentId: $studentId
          durationType: $durationType
          startDate: $startDate
          endDate: $endDate
          reason: $reason
          periodIds: $periodIds
          attachments: $attachments
          curriculumProgramId: $curriculumProgramId
        }
      ) {
        response {
          ...attendanceExcusalItem
        }
      }
    }
  }
  ${studentAttendanceFragment.attendanceExcusal}
`;

export const createAdminAttendanceExcusalMutation = gql`
  mutation createAdminAttendanceExcusal(
    $studentIds: [ID!]
    $durationType: ATTENDANCE_EXCUSAL_DURATION_TYPE_ENUM
    $startDate: String
    $endDate: String
    $reason: String
    $periodIds: [ID!]
    $attachments: [AttachmentInput!]
    $curriculumProgramId: ID
    $academicYearId: ID
    $attendanceOptionId: ID
  ) {
    platform {
      createAdminAttendanceExcusal(
        input: {
          studentIds: $studentIds
          durationType: $durationType
          startDate: $startDate
          endDate: $endDate
          reason: $reason
          periodIds: $periodIds
          attachments: $attachments
          curriculumProgramId: $curriculumProgramId
          academicYearId: $academicYearId
          attendanceOptionId: $attendanceOptionId
        }
      ) {
        warning
        isSuccess
        response {
          id
        }
      }
    }
  }
`;

export const updateAttendanceExcusalMutation = gql`
  mutation updateAttendanceExcusal(
    $excusalId: ID!
    $durationType: ATTENDANCE_EXCUSAL_DURATION_TYPE_ENUM
    $startDate: String
    $endDate: String
    $reason: String
    $periodIds: [ID!]
    $newAttachments: [AttachmentInput!]
    $removedAttachments: [ID!]
    $curriculumProgramId: ID!
    $academicYearId: ID!
    $attendanceOptionId: ID
  ) {
    platform {
      updateAttendanceExcusal(
        input: {
          excusalId: $excusalId
          durationType: $durationType
          startDate: $startDate
          endDate: $endDate
          reason: $reason
          periodIds: $periodIds
          newAttachments: $newAttachments
          removedAttachments: $removedAttachments
          curriculumProgramId: $curriculumProgramId
          academicYearId: $academicYearId
          attendanceOptionId: $attendanceOptionId
        }
      ) {
        response {
          ...attendanceExcusalItem
        }
      }
    }
  }
  ${studentAttendanceFragment.attendanceExcusal}
`;

export const deleteAttendanceExcusalMutation = gql`
  mutation deleteAttendanceExcusal($input: DeleteAttendanceExcusalInput!) {
    platform {
      deleteAttendanceExcusal(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
